export const getDoctor = (doctor, subscriptionType, role) => {
    if (!doctor.userId)
        return;
    return {
        uid: doctor.uuid,
        username: doctor.state.username,
        status: doctor.state.status,
        userId: doctor.userId,
        roomId: doctor.roomId,
        type: doctor.type,
        subscriptionType,
        institutionRole: role,
    };
};
export const getPatients = (patients) => {
    return patients.map((patient) => ({
        uid: patient.uuid,
        username: patient.state.username,
        status: patient.state.status,
        roomId: patient.roomId,
        type: patient.type,
        token: patient.state.token,
        callInitiator: patient.state.callInitiator,
    }));
};
export const getCurrentUser = (user, lowQualityPhoto) => {
    if (!user.userId)
        return;
    return {
        uid: user.uuid,
        username: user.state.username,
        status: user.state.status,
        userId: user.userId,
        roomId: user.roomId,
        type: user.type,
        token: user.state.token,
        callInitiator: user.state.callInitiator,
        lowQualityPhoto: lowQualityPhoto,
    };
};
export const getInstitution = (institution) => {
    return {
        id: institution.id,
        institutionAccess: institution.institutionAccess,
    };
};
export const getPatientsOnCall = (actions) => {
    return actions.activeProvider().peopleCollection.getPatients();
};
